import { authenticationConstants } from "../constants/authentication.constants";
import { CommonUser } from '../types';
import { settingsConstants } from "./../constants/settings.constants";
import * as axiosConfig from "../config/axiosConfig";
import { resetUI } from "../utils/bluetooth";
import i18next from '../i18n';

export interface AuthenticationState {
    requesting: boolean;
    login: boolean;
    redirectURL?: string;
    user?: CommonUser;
    token: string;
    errors: boolean;
}

const defaultState = {
    requesting: false,
    login: false,
    redirectURL: undefined,
    user: undefined,
    token: "",
    errors: false
};

export const authentication = (state: AuthenticationState = defaultState, action: any) => {
    switch (action.type) {
        case authenticationConstants.LOGIN_REQUEST:
        case 'USER_LOGIN_REQUEST': // Handle user login request action
            return {
                ...state,
                requesting: true,
                login: false
            };
        case authenticationConstants.LOGIN_SUCCESS:
        case 'USER_LOGIN_SUCCESS': // Handle user login success action
            axiosConfig.setToken(action.token);
            return {
                ...state,
                requesting: false,
                login: true,
                user: action.user,
                token: action.token,
            };
        case authenticationConstants.LOGIN_FAILURE:
        case 'USER_LOGIN_FAILURE': // Handle user login failure action
            return {
                ...state,
                requesting: false,
                login: false,
                errors: true
            };
        case authenticationConstants.MODIFY_SUCCESS:
            return {
                ...state,
                user: action.data
            };
        case settingsConstants.FETCH_SUCCESS:
            return { ...state, user: action.user };
        case settingsConstants.FETCH_FAILURE:
            const status: string = action.data != undefined ? action.data.status.toString() : "failure";
            if (status[0] === "4") {
                return { ...state, login: false, user: undefined, errors: true };
            }
            return { ...state };
        case settingsConstants.IMAGE_UPLOAD_SUCCESS:
            let user = { ...state.user } as CommonUser;
            user.imageUrl = action.imageUrl;
            return { ...state, user: user };
        case authenticationConstants.MODIFY_DISPLAY_SETTINGS_SUCCESS:
            if(state.user.displaySettings.lang != action.data.lang){
                i18next.changeLanguage(action.data.lang);
            }
            return {
                ...state,
                user: { ...state.user, displaySettings: action.data }
            };
        case authenticationConstants.MODIFY_PRIVACY_SETTINGS_SUCCESS:
            return{
                ...state,
                user:{...state.user, privacySettings: action.data}
            };
        case authenticationConstants.LOGOUT:
            axiosConfig.setToken('');
            return { ...defaultState };
        case authenticationConstants.REDIRECT_URL:
            return { ...state, redirectURL: action.url };
        default:
            return { ...state };
    }
};
